export default {
    title: 'light',

    colors: {
        primary: '#44CCFF',
        secundary: '#fff',

        background: '#f5f5f5',
        text: '#333'
    },

};